// extracted by mini-css-extract-plugin
export var actionButton = "_s0-0";
export var actionMenuContainer = "_s0-i";
export var bubble = "_s0-2";
export var bubbleActionMenu = "_s0-j";
export var bubbleContext = "_s0-6";
export var bubbleItems = "_s0-7";
export var customer = "_s0-3";
export var divider = "_s0-8";
export var fileList = "_s0-9";
export var hiddenComment = "_s0-o";
export var infoAbove = "_s0-a";
export var internal = "_s0-4";
export var lightActionButton = "_s0-1";
export var link = "_s0-b";
export var merchant = "_s0-5";
export var message = "_s0-c";
export var profilePicture = "_s0-e";
export var quillToolbarContainer = "_s0-f";
export var senderDate = "_s0-g";
export var senderDateCustomer = "_s0-h";
export var senderName = "_s0-d";
export var time = "_s0-k";
export var uploadedImage = "_s0-l";
export var username = "_s0-m";
export var xsmall = "_s0-n";